import script from "./BadgeInput.vue?vue&type=script&setup=true&lang=js"
export * from "./BadgeInput.vue?vue&type=script&setup=true&lang=js"

import "./BadgeInput.vue?vue&type=style&index=0&id=294f1516&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-294f1516"]])

export default __exports__